module.exports = __webpack_public_path__ + "img/article_ad_banner_03.0ff6f374.png";